import { useState } from 'react';
import styled from 'styled-components';
import { useScrollspy } from '../../../hooks/useScrollspy';
import { Text14Medium } from '../../../mixins/mixins';

const NavbarComponent = styled.div`
  display: flex;
`;

const NavItem = styled.a<{ activeItem: boolean }>`
  position: relative;
  display: flex;
  ${Text14Medium};
  margin-left: 24px;
  text-decoration: none;
  color: ${props => (props.activeItem ? 'white' : 'rgba(255, 255, 255, 0.6)')};
  :hover {
    color: rgba(255, 255, 255, 1);
    cursor: pointer;
  }
  &.menu-link-active:before {
    content: '';
    position: absolute;
    width: 4px;
    height: 4px;
    top: 9px;
    left: -8px;
    border-radius: 50%;
    background: rgba(219, 255, 0, 1);
  }
`;

const navItems = [
  { name: 'Start', value: 'start' },
  { name: 'Office', value: 'office' },
  { name: 'About us', value: 'about' },
  { name: 'Feedback', value: 'feedback' },
];

const Navbar = () => {
  const ids = ['start', 'office', 'about', 'feedback'];
  const activeId = useScrollspy(ids, 54);
  const [navActive, setNavActive] = useState('Старт');
  return (
    <NavbarComponent>
      {navItems.map(navItemName => (
        <NavItem
          key={navItemName.name}
          onClick={() => setNavActive(navItemName.name)}
          href={`/#${navItemName.value}`}
          activeItem={navItemName.name === navActive}
          className={`menu-link ${
            navItemName.value === activeId && 'menu-link-active'
          }`}
        >
          {navItemName.name}
        </NavItem>
      ))}
    </NavbarComponent>
  );
};

export default Navbar;
